import { api } from "@/api";
import { ApiResponseType, PostPlayersSignUpRequst, PostPlayersSignUpResponse, PostVerificationCodeRequest, PostVerificationCodeResponse } from "@/api/type";

export const postPlayersSignUp = async(data: PostPlayersSignUpRequst
) => {
    try {
        const res = await api.post<ApiResponseType<PostPlayersSignUpResponse>>(`/api/web/visitors/players`, data)
        return res.data;
    } catch (err) {
        console.error("postPlayersSignUp API error:", err)
        throw err;
    }
}